export default "__VITE_ASSET__Bl_IAkT5__"